var _style, _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-179 55.4 40.5 40.6",
    style: {
      enableBackground: "new -179 55.4 40.5 40.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2E2E2E;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "savings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Final"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MP_x5F_Desktop-_x28_1200px_x29_-Mobile-2",
    transform: "translate(-670.000000, -523.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_cart",
    transform: "translate(666.000000, 518.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(3.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-27",
    className: "st0",
    d: "M-159.6,86.9c0,1-0.8,1.8-1.8,1.8c-1,0-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8 C-160.4,85.1-159.6,85.9-159.6,86.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-28",
    className: "st0",
    d: "M-150.2,86.9c0,1-0.8,1.8-1.8,1.8c-1,0-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8 C-151,85.1-150.2,85.9-150.2,86.9"
  }))))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-147,70.5c-0.2-0.2-0.4-0.3-0.7-0.3h-18.8l-0.9-3.5c-0.1-0.4-0.4-0.6-0.8-0.6h-2.9c-0.5,0-0.8,0.4-0.8,0.8 s0.4,0.8,0.8,0.8h2.3l3.9,14.7c0.1,0.4,0.4,0.6,0.8,0.6h13.5c0.4,0,0.7-0.3,0.8-0.6l2.9-11.2C-146.8,71-146.8,70.7-147,70.5z  M-148.7,71.9l-2.5,9.5h-12.2l-2.6-9.5H-148.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-158.8,55.6c-11,0-20,9-20,20c0,11,9,20,20,20s20-9,20-20C-138.8,64.5-147.8,55.6-158.8,55.6z M-158.8,94.6 c-10.5,0-19-8.5-19-19c0-10.5,8.5-19,19-19s19,8.5,19,19C-139.8,86.1-148.3,94.6-158.8,94.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartCircle);
export default __webpack_public_path__ + "static/media/cart-circle.90d20ab22aa07942a0e7ba2d7c4078f1.svg";
export { ForwardRef as ReactComponent };